import { render, staticRenderFns } from "./EdTwitterDestination.vue?vue&type=template&id=49d7368c&"
import script from "./EdTwitterDestination.vue?vue&type=script&lang=js&"
export * from "./EdTwitterDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports